const constants = {
	CLASS_COLLAPSED: "collapsed",
	CLASS_EXPANDED: "expanded",
	CLASS_ACTIVE: "active",
	CLASS_ACCORDION: "accordion",
	CLASS_ACCORDION_ROOT: "accordion-root",
	SELECTOR_COMPONENTS: "[class*='component-']",
	SELECTOR_EXPANDABLE_CONTENT: "[xyl-element='accordion-content']",
	SELECTOR_TRIGGER: "accordion-trigger",
	ELEMENT_ACCORDION_ITEM: "accordion-item",
};

export { constants };
